'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tooltip/lib/index.js
 ** module id = 238
 ** module chunks = 0
 **/